import {
	SET_HISTORY_LOGS,
	CLEAR_HISTORY_LOGS,
	SET_USERS,
	CLEAR_USERS,
	SET_TRANSACTIONS,
	CLEAR_TRANSACTIONS,
	TOAST_MESSAGES_PUSH
} from './mutation-types';

import { ApiLogService as api } from '@/services/axiosHelper';
import { ApiService as supportApi } from '@/services/axiosHelper';

import _ from 'lodash';

const capitalizeWords = str => {
	return str.replace(/\b\w/g, match => match.toUpperCase());
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'historyLogs',
	namespaced: true,
	state: {
		historyLogs: {},
		users: [],
		transactions: {}
	},
	mutations: {
		[SET_HISTORY_LOGS](state, historyLogs) {
			state.historyLogs = historyLogs;
		},
		[CLEAR_HISTORY_LOGS](state) {
			state.historyLogs = {
				countPerPage: 10,
				items: [],
				page: 1,
				totalCount: 0,
				totalPageCount: 0
			};
		},
		[SET_USERS](state, users) {
			users.items.forEach(user => {
				state.users.push({
					text: user.userName,
					value: user.userId
				});
			});
		},
		[CLEAR_USERS](state) {
			state.users = [];
		},
		[SET_TRANSACTIONS](state, transactions) {
			state.transactions = transactions;
		},
		[CLEAR_TRANSACTIONS](state) {
			state.transactions = {};
		}
	},
	actions: {
		async getHistoryLogs({ commit, dispatch }, parameters) {
			let params = _.cloneDeep(parameters);

			const valuesToRemove = [undefined, ''];
			params = _.omitBy(params, value => valuesToRemove.includes(value));

			commit(CLEAR_HISTORY_LOGS);

			return new Promise((resolve, reject) => {
				supportApi
					.post('/versionhistory', params)
					.then(res => {
						commit(SET_HISTORY_LOGS, res);
						resolve();
					})
					.catch(err => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: err
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		async getUsers({ commit, dispatch }, { entityType, changedEntityId }) {
			commit(CLEAR_USERS);
			const prod_envs = ['master-hotfix', 'production'];
			const qa_envs = [
				'qa',
				'qa-test1',
				'qa-test2',
				'qa-test3',
				'qa-test4'
			];
			const params = {
				environment: prod_envs.includes(process.env.NODE_ENV)
					? 'prod'
					: qa_envs.includes(process.env.NODE_ENV)
					? 'qa'
					: process.env.NODE_ENV,
				source: 'VueSupport',
				entityType,
				changedEntityId,
				logType: 'VersionHistoryLogEntry'
			};
			return new Promise((resolve, reject) => {
				supportApi
					.get(`/logs/users`, {
						params
					})
					.then(res => {
						let cloneResp = _.cloneDeep(res);
						const uniqueUserIds = new Set();
						const uniqueUsers = cloneResp.items.filter(item => {
							if (!uniqueUserIds.has(item.userId)) {
								uniqueUserIds.add(item.userId);
								return true;
							}
							return false;
						});

						cloneResp.items = uniqueUsers.map(item => ({
							userId: item.userId,
							userName: capitalizeWords(item.userName)
						}));
						cloneResp.totalCount = cloneResp.items.length;

						commit(SET_USERS, cloneResp);
						resolve();
					})
					.catch(err => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: err
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		async getTransactions({ commit, dispatch }, parameters) {
			let params = _.cloneDeep(parameters);

			const valuesToRemove = [undefined, '', 'all'];
			params = _.omitBy(params, value => valuesToRemove.includes(value));

			commit(CLEAR_TRANSACTIONS);

			return new Promise((resolve, reject) => {
				api.get('/securevue/transactions', {
					params
				})
					.then(res => {
						commit(SET_TRANSACTIONS, res);
						resolve();
					})
					.catch(err => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: err
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		}
	}
};
